import React, { useEffect, useState, useRef, useCallback } from "react";
import edit from "../../Assets/svg/edit.svg";
import dt from "../../Assets/svg/delete.svg";
import lar from "../../Assets/svg/lar.svg";
import rar from "../../Assets/svg/rar.svg";
import { Container, Row, Col, Toast, ToastContainer } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import DeleteModal from "../common/DeleteModal";
import ListFooter from "../common/ListFooter.jsx";
import ReportButton from "../common/ReportButton.jsx";
import { useExcelActions } from "../../hooks/useExcelActions";
import { useGlobal } from "../../GlobalContext.js";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../../services/api-service";

const RegisterFieldList = () => {
  const { rolePermissionList } = useGlobal();
  const navigate = useNavigate();

  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true
    ) > -1
      ? true
      : false;
  }

  const [fieldList, setFieldList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10); // or any default value
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [status, setStatus] = useState("All");
  const [hoveredIndex, setHoveredIndex] = useState(null);

  useEffect(() => {
    getListData(searchTerm);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, itemsPerPage, itemOffset]);
  /* const pageCount = Math.ceil(fieldList.length / itemsPerPage); */

  const handlePageClick = useCallback(
    (event) => {
      const newOffset = event.selected * itemsPerPage;
      setItemOffset(newOffset); // Not event.selected
    },
    [itemsPerPage]
  );
  const [deleteId, setDeleteId] = useState(null);
  const deleteFieldConfig = async (id) => {
    setDeleteId(id);
    setIsOpenDelete(true);
  };
  const deleteApi = async () => {
    if (deleteId != null) {
      const response = await apiCall("delete", `field_config/${deleteId}`);
      if (response?.status === 200 && response.data?.success === true) {
        setDeleteId(null);
        setIsOpenDelete(false);
        getListData("");
      }
      setSnackbarMessage(response?.data?.message ?? "Something went wrong");
      setSnackbarStatus(response?.data?.success === true);
      handleSnackbarShow();
    }
  };
  const debounce = (func, delay) => {
    let timer;
    return (...args) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        func(...args);
      }, delay);
    };
  };
  const handleSearch = debounce((term) => {
    // A new search starts from the first page. If already on page 1, fetch
    // directly; otherwise reset the offset and let the itemOffset effect fetch.
    if (itemOffset === 0) {
      getListData(term, 0);
    } else {
      setItemOffset(0);
    }
  }, 1000);
  const getListData = async (term, skip = itemOffset) => {
    const response = await apiCall("get", "field_config", null, {
      params: {
        limit: itemsPerPage,
        skip,
        search: term,
        status,
      },
    });
    if (response?.status === 200 && response.data?.success === true) {
      const totalPages = response.data.total_pgs ?? 0;
      setTotalCount(response.data.total_rec ?? 0);
      setPageCount(totalPages);
      setFieldList(response.data.configs ?? []);

      // Snap back to the last page if the current page is now out of range.
      const currentPage = Math.floor(skip / itemsPerPage);
      if (currentPage > totalPages) {
        setItemOffset(totalPages * itemsPerPage);
      }
    }
  };

  const { reportLoading, downloadReport } = useExcelActions("field", getListData, {
    setSnackbarMessage,
    setSnackbarStatus,
    handleSnackbarShow,
  }, "field_configurations");

  return (
    <Container fluid style={{ width: "100%", padding: "0px" }}>
      <div className="d-flex side4">
        {/* <div className="d-none d-lg-block">
          <Sidebar selectedTab={"Field configuration"} />
        </div> */}
        <Row
          sm={12}
          style={{
            "--bs-gutter-x": "0px",
            margin: "0px",
            width: "100%",
            // height: "100vh",
            overflow: "auto",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            justifyContent: "center",
          }}
        >
          <Col>
            {/* <div className="top3">
              <Topbar selectedTab={"Field configuration"} />
            </div> */}
            <div className="maincontent3">
              <div
                style={{
                  borderRadius: "16px",
                  padding: "16px",
                  backgroundColor: "#FFFFFF",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ gap: "12px" }}>
                  <div>
                    <span
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "700",
                        fontSize: "20px",
                        lineHeight: "22px",
                        color: "#212129",
                      }}
                    >
                      Register Fields
                    </span>
                    <div
                      style={{
                        fontFamily: "Satoshi",
                        fontWeight: "400",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#8790A1",
                      }}
                    >
                      Manage your register fields list here
                    </div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                  
                  {checkPermission(
                    "Field configuration",
                    "create_permission"
                  ) && (
                    <button
                      style={{
                        height: "40px",
                        borderRadius: "100px",
                        padding: "8px 16px 8px 16px",
                        gap: "8px",
                        backgroundColor: "#6929E2",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: "none",
                      }}
                      onClick={() => navigate("/register/add")}
                    >
                      <p
                        style={{
                          margin: "0",
                          fontFamily: "Satoshi",
                          fontWeight: "700",
                          fontSize: "14px",
                          lineHeight: "18.9px",
                          color: "#FFFFFF",
                        }}
                      >
                        + New Register Field
                      </p>
                    </button>
                  )}
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  margin: "16px",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <p
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "500",
                      fontSize: "14px",
                      lineHeight: "22px",
                      color: "#212129",
                      margin: "0",
                    }}
                  >
                    Total field config: {totalCount}
                  </p>
                </div>

                <div
                  style={{
                    height: "40px",
                    gap: "12px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginRight: "16px",
                  }}
                >
                  <div>
                    <input
                      type="search"
                      placeholder="Search..."
                      onChange={(event) => {
                        setSearchTerm(event.target.value);
                        handleSearch(event.target.value);
                      }}
                      style={{
                        width: "300px",
                        height: "40px",
                        borderRadius: "100px",
                        border: "0.5px solid #E5E5E5",
                        padding: "14px 16px 14px 16px",
                        gap: "6px",
                        backgroundColor: "#FFFFFF",
                      }}
                    />
                  </div>

                  <ReportButton
                    loading={reportLoading}
                    onClick={() => downloadReport({ status, search: searchTerm })}
                  />
                </div>
              </div>

              <div
                style={{
                  borderRadius: "8px",
                  paddingTop: "16px",
                  paddingBottom: "16px",
                  backgroundColor: "#FFFFFF",
                }}
              >
                <div
                  style={{
                    height: "42px",
                    display: "flex",
                    alignItems: "center",
                    padding: "12px 16px 12px 16px",
                    backgroundColor: "#F2F2F2",
                  }}
                >
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "2",
                    }}
                  >
                    Code
                  </span>
                  <span
                    style={{
                      fontFamily: "Satoshi",
                      fontWeight: "700",
                      fontSize: "13px",
                      lineHeight: "17.55px",
                      color: "#212129",
                      flex: "4",
                    }}
                  >
                    Name
                  </span>
                  <span
                    style={{
                      flex: "4",
                    }}
                  ></span>
                </div>
                <div>
                  {fieldList.map((item, index) => (
                    <div
                      key={"table-list" + index}
                      style={{ position: "relative", cursor: "pointer" }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <div
                        style={{
                          height: "40px",
                          display: "flex",
                          alignItems: "center",
                          padding: "6px 16px 6px 16px",
                          backgroundColor: hoveredIndex === index ? "#F8F9FD" : "#FFFFFF",
                          borderBottom: "0.6px solid #D4DDE7",
                          transition: "background-color 0.15s ease",
                        }}
                      >
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "2",
                          }}
                        >
                          {item.code ?? "-"}
                        </span>
                        <span
                          style={{
                            fontFamily: "Satoshi",
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "22px",
                            color: "#212129",
                            flex: "4",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                          }}
                        >
                          {item.name ?? "-"}
                        </span>
                        <div
                          style={{
                            flex: "4",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-start",
                            visibility: hoveredIndex === index ? "visible" : "hidden",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            {checkPermission(
                              "Field configuration",
                              "edit_permission"
                            ) && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/register/add", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={edit}
                                  alt="edit"
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}

                            {checkPermission(
                              "Field configuration",
                              "delete_permission"
                            ) && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteFieldConfig(item.id);
                                }}
                                style={{
                                  width: "32px",
                                  height: "32px",
                                  borderRadius: "100px",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  backgroundColor: "#FFFFFF",
                                }}
                              >
                                <img
                                  src={dt}
                                  alt="delete"
                                  style={{ width: "14px", height: "14px" }}
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <ListFooter
                  itemsPerPage={itemsPerPage}
                  onItemsPerPageChange={(n) => {
                    setItemsPerPage(n);
                    setItemOffset(0);
                  }}
                  pagination={
                    <ReactPaginate
                      previousLabel={
                        <img src={lar} className="ar3" alt="previous" />
                      }
                      nextLabel={<img src={rar} className="ar3" alt="next" />}
                      breakLabel={"..."}
                      pageCount={pageCount + 1}
                      forcePage={Math.min(
                        Math.floor(itemOffset / itemsPerPage),
                        pageCount
                      )}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageClick}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />
                  }
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <DeleteModal
        isOpen={
          isOpenDelete &&
          checkPermission("Field configuration", "delete_permission")
        }
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteApi}
        title="Delete field config"
        message="You won’t able to access your field after deleting. Are you sure want to delete?"
      />
      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          {/*  <Toast.Header>
                                <strong className="mr-auto">Snackbar Title</strong>
                              </Toast.Header> */}
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </Container>
  );
};

export default RegisterFieldList;
